import {Grid, SxProps} from '@mui/material';

import {Question} from './Question';
import {EmpionPaper} from '../../../../../../../components/EmpionPaper/EmpionPaper';
import {orangeColors} from '../../../../../../../layouts/theme/designSystem';
import {Answer} from '../../../../../../../lib/api/RequestBodies/features/company/Questionnaires/QuestionnaireRequestBodies';
import {HappinessItem, Item} from '../../../types/SurveyQuestionnaireTypes';

interface SetOfQuestionsProps {
  questions: Item[] | HappinessItem[];
  answers: Answer[];
  onAnswer: (event: any) => void;
  usageCase?: string;
}

export const SetOfQuestions = ({questions, onAnswer, usageCase, answers}: SetOfQuestionsProps) => {
  const empionPaperStyle: SxProps = {
    width: {xs: '100%', sm: '536px', md: '736px'},
    height: 'fit-content',
    backgroundColor: 'white',
    borderRadius: '16px',
    border: `2px solid ${orangeColors[4]}`,
    padding: {xs: '10px', sm: '20px', md: '30px', lg: '30px'},
    marginBottom: '20px',
    minHeight: '300px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  };

  return (
    <Grid container marginTop={{xs: 2, sm: 3, md: 4, lg: 6}}>
      {questions.map((item) => {
        return (
          <Grid
            container
            sx={{
              flexDirection: 'column',
              alignItems: 'center',
            }}
            key={item.resourceId}
          >
            <EmpionPaper sx={empionPaperStyle}>
              <Question
                data={item}
                currentAnswer={answers.find((answer) => answer.resourceId === item.resourceId)}
                onAnswer={onAnswer}
                usageCase={usageCase}
              />
            </EmpionPaper>
          </Grid>
        );
      })}
    </Grid>
  );
};
